import type { CustomFieldValidatorState } from '@pbt/pbt-ui-components'

export const MIN_CLIENT_CHARGE_AMOUNT = 0.5

export enum CancelTiming {
  IMMEDIATELY = 'immediately',
  END_OF_TERM = 'end_of_term',
}

export type CancelData = {
  cancelTiming: CancelTiming
  chargeClient?: number
  creditBalance?: number
  notes: string
  otherReason?: string
  reason: string
  refundClient?: number
  writeOff?: number
}

export const isFullWriteOff = (
  writeOffAmount: number,
  paymentAmount: number,
  isCharge: boolean,
) => isCharge && paymentAmount === 0 && writeOffAmount > 0

export const createChargeClientAmountValidator =
  (isCharge: boolean) =>
  ({
    value: chargeClientValue,
    state: { writeOff: writeOffValue, cancelTiming },
  }: CustomFieldValidatorState) => {
    const isEndOfTerm = cancelTiming === CancelTiming.END_OF_TERM
    if (!isCharge || isEndOfTerm) {
      return true
    }
    return (
      isFullWriteOff(writeOffValue, chargeClientValue, isCharge) ||
      chargeClientValue >= MIN_CLIENT_CHARGE_AMOUNT
    )
  }
